module.exports = __webpack_public_path__ + "img/framees.ee1f9a53.png";